import { Box, Typography, Container, Card, CardContent, Grid, Paper, CardMedia } from "@mui/material";
import { styled } from "@mui/material/styles";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";

const HeroSection = styled(Box)(({ theme }) => ({
    position: "relative",
    minHeight: "50vh",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    backgroundImage: `url(${process.env.PUBLIC_URL}/medicine-1.jpg)`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    padding: theme.spacing(2, 4),
    marginBottom: theme.spacing(8),

    // Create the black overlay
    "::after": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Adjust opacity here (0.5 = 50% black)
        zIndex: 1,
    },

    // Ensure content appears above the overlay
    "& > *": {
        position: "relative",
        zIndex: 2,
    },
}));

const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: theme.spacing(2),
    overflow: "hidden",
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
        transform: "translateY(-5px)",
    },
}));
const StyledEventCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'translateY(-8px)',
    },
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
}));

const IconWrapper = styled(Box)(({ theme }) => ({
    width: 60,
    height: 60,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    marginBottom: theme.spacing(2),
    background: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
}));
const EventTitle = styled(Typography)(({ theme }) => ({
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -8,
      left: 0,
      width: 60,
      height: 3,
      backgroundColor: theme.palette.primary.main,
    },
  }));
function JanAushadhi() {
    const janAushadhiContent = {
        title: "Jan Aushadhi",
        sections: [
            {
                image: "/Bio-energy-img.jpg",
                content: `National Yuva Cooperative Society(NYCS) believes and works towards making potential growth for a sustainable life a deﬁnite possibility amongst people of India particularly the youth. Sustainable growth of an individual is a product of his physical and mental strength coupled with his efforts. Thus, good health is a prime factor in overall development of youth and nation.
    
                In line with Prime Minister Shri. Narendra Modi’s vision of “Swastha Bharat” Department of Pharmaceuticals has launched the PMBJP scheme to take their initiative to make quality medicines and affordable medicines a reality in India. NYCS has partnered with Bureau of Pharma PSUs of India (BPPI), a division of the department, for implementing the PMBJP scheme and establishing multiple Jan Aushadhi Centres all across the nation to make effective and affordable generic medicine easily accessible to the people. This partnership targets to open such medical stores in every block and gram panchayat. Chemicals & Fertilisers Minister Shri. Ananth Kumar and NYCS then President Shri. Rajesh Pande signed on the Memorandum of Understanding. NYCS with its vast network of district and state representatives aims to extend the outreach of this program so as to achieve duel beneﬁts of providing quality medicine to the society and to inject entrepreneurship amongst the youth by opening Janaushadhi Kendras for business.
    
                The price of generic medicines sold in the Janaushadhi Kendras is significantly lower than the average rate of leading brands, but are equally effective. Even the anti-cancer and anti-diabetic medicines are as efficient as the expensive commercial brands. The quality of the medicines provided in these Kendras is WHO compliant. Government is working to promote the indigenous generic drug industry and make it globally competitive.`
            },
            {
                image: "/img-2.jpg",
                content: `NYCS believes that with its vast network of youth representatives, the “yuva” energy could be channelized in achieving this goal. We have begun our mission and invite public to join us and strengthen our efforts. We are looking for genuine public partners to participate in the scheme.
    
                NYCS invites anyone who is interested in this entrepreneurial opportunity for discussion of the further details, formalities, rules and procedure for opening a Pradhan Mandtri Janaushadhi Kendra with NYCS. One can also fill the form on NYCS website to get connected with the scheme.`
            },

        ]
    };
    return (
        <Box>
            {/* Hero Section */}
            <HeroSection>
                <Box sx={{ textAlign: "center", maxWidth: { xs: 300, md: 800 } }}>
                    <IconWrapper>
                        <MedicalServicesIcon color="primary" sx={{ fontSize: 30 }} />
                    </IconWrapper>
                    <Typography variant="h2" component="h1" gutterBottom sx={{ typography: { xs: "h4", md: "h2" } }}>
                        {janAushadhiContent.title}
                    </Typography>
                    <Typography variant="h5" sx={{ typography: { xs: "body1", md: "h5" } }}>
                        Affordable Medicines, Healthier Nation – Empowering Lives with Jan Aushadhi
                    </Typography>
                </Box>
            </HeroSection>
            <Container maxWidth="lg" sx={{ my: 8 }}>
          {/* First Section */}
          <Grid container spacing={4} sx={{ mb: 6 }}>
            <Grid item xs={12}>
              <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                  <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={12}>
                      <Box
                        component="img"
                        src="/medicine-3.jpg"
                        alt="Jan Aushadhi Initiative"
                        sx={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: 2,
                          mb: { xs: 3, md: 0 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: 1.8,
                          textAlign: 'justify'
                        }}
                      >
                        National Yuva Cooperative Society(NYCS) believes and works towards making potential growth for a sustainable life a deﬁnite possibility amongst people of India particularly the youth. Sustainable growth of an individual is a product of his physical and mental strength coupled with his efforts. Thus, good health is a prime factor in overall development of youth and nation.
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: 1.8,
                          mt: 2,
                          textAlign: 'justify'
                        }}
                      >
                        In line with Prime Minister Shri. Narendra Modi's vision of "Swastha Bharat" Department of Pharmaceuticals has launched the PMBJP scheme to take their initiative to make quality medicines and affordable medicines a reality in India. NYCS has partnered with Bureau of Pharma PSUs of India (BPPI), a division of the department, for implementing the PMBJP scheme and establishing multiple Jan Aushadhi Centres all across the nation to make effective and affordable generic medicine easily accessible to the people. This partnership targets to open such medical stores in every block and gram panchayat. Chemicals & Fertilisers Minister Shri. Ananth Kumar and NYCS then President Shri. Rajesh Pande signed on the Memorandum of Understanding. NYCS with its vast network of district and state representatives aims to extend the outreach of this program so as to achieve duel beneﬁts of providing quality medicine to the society and to inject entrepreneurship amongst the youth by opening Janaushadhi Kendras for business.
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: 1.8,
                          mt: 2,
                          textAlign: 'justify'
                        }}
                      >
                        The price of generic medicines sold in the Janaushadhi Kendras is significantly lower than the average rate of leading brands, but are equally effective. Even the anti-cancer and anti-diabetic medicines are as efficient as the expensive commercial brands. The quality of the medicines provided in these Kendras is WHO compliant. Government is working to promote the indigenous generic drug industry and make it globally competitive.
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
    
          {/* Second Section */}
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Card elevation={3} sx={{ borderRadius: 2 }}>
                <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                  <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6} sx={{ order: { xs: 2, md: 1 } }}>
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: 1.8,
                          textAlign: 'justify'
                        }}
                      >
                        NYCS believes that with its vast network of youth representatives, the "yuva" energy could be channelized in achieving this goal. We have begun our mission and invite public to join us and strengthen our efforts. We are looking for genuine public partners to participate in the scheme.
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          lineHeight: 1.8,
                          mt: 2,
                          textAlign: 'justify'
                        }}
                      >
                        NYCS invites anyone who is interested in this entrepreneurial opportunity for discussion of the further details, formalities, rules and procedure for opening a Pradhan Mandtri Janaushadhi Kendra with NYCS. One can also fill the form on NYCS website to get connected with the scheme.
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={6} sx={{ order: { xs: 1, md: 2 } }}>
                      <Box
                        component="img"
                        src="/medicine-2.jpg"
                        alt="Jan Aushadhi Program"
                        sx={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: 2,
                          mb: { xs: 3, md: 0 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>

           
        </Box>
    )
}

export default JanAushadhi
